
export default {
  name: 'ListingMattressFinderResult',
  props: {
    mattressFinder: {
      type: Array,
      default() {
        return [];
      },
    },
    finalStepsInfo: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    resultStep() {
      const arr = this.finalStepsInfo.map((item) => {
        const fullItem = this.mattressFinder.find((elem) => elem.attributeCode === item.attributeCode);
        if (!fullItem) return item;
        const result = {
          ...item,
          label: fullItem.label,
          name: fullItem.name,
        };
        const option = fullItem.items.find((i) => i.value === item.value.join());
        if (!option) return result;
        result.option = option;
        if (result.option.name.includes('Sleeper')) {
          result.option = {
            ...result.option,
            name: result.option.name.replace(' Sleeper', ''),
          };
        }
        return result;
      });
      return arr;
    },
  },
  methods: {
    reset() {
      this.$emit('reset-step');
    },
  },
};
